import "./footer.styles.scss";

const Footer = () => {
	return (
		<div className="footer">
			<a href="http://xprtcomputersolution.com">
				xprt computer solution &copy; 2021 Ph:+91-8126904185
			</a>
		</div>
	);
};

export default Footer;
